import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ItemType } from 'antd/es/menu/interface';
import { Dropdown, Menu } from 'antd';
import DropdownOption from '@/interfaces/DropdownOption';
import { MoreOutlined } from '@ant-design/icons';

interface Props{
  dropdownMenu: DropdownOption[];
} 

const DotsDropdown = ({ dropdownMenu } : Props) => {
  const menu = () => {
    const items: ItemType[] = dropdownMenu.map(dropdownOption => ({
      key: uuidv4(),
      disabled: !!dropdownOption.disabled,
      label: dropdownOption.label,
      danger: dropdownOption.danger,
      onClick: dropdownOption.func,
    }));

    return (
      <Menu items={items} />
    );
  };

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      <MoreOutlined className="align-icon" style={{ cursor: 'pointer' }} />
    </Dropdown>
  );
};

export default DotsDropdown;
